/* global axios */

class DealLossReasonsAPI {
  get(accountId) {
    return axios.get(`/api/v1/accounts/${accountId}/deal_loss_reasons`);
  }

  show(accountId, id) {
    return axios.get(`/api/v1/accounts/${accountId}/deal_loss_reasons/${id}`);
  }

  create(accountId, payload) {
    return axios.post(`/api/v1/accounts/${accountId}/deal_loss_reasons`, {
      deal_loss_reason: payload,
    });
  }

  update(accountId, id, payload) {
    return axios.patch(`/api/v1/accounts/${accountId}/deal_loss_reasons/${id}`, {
      deal_loss_reason: payload,
    });
  }

  delete(accountId, id) {
    return axios.delete(`/api/v1/accounts/${accountId}/deal_loss_reasons/${id}`);
  }
}

export default new DealLossReasonsAPI();
